import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as messageAlert from '../../../actions/messageAlertAction';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import CustomAlertTemplate from './CustomAlertTemplate';

class MessageAlert extends React.Component {
  render() {
    return (
      <div>
        <Alert stack={{ limit: 1 }} effect="slide" timeout={5000} contentTemplate={CustomAlertTemplate} html={true} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.messageAlert
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageAlert);
